import { create } from "zustand";

import { STORAGE_KEYS } from "@/shared/constants/storage-keys";
import { storage } from "@/shared/lib/storage";

export type PreviewPlacement = "right" | "bottom";

const SUPPORTED_PREVIEW_PLACEMENTS: PreviewPlacement[] = ["right", "bottom"];

function getInitialPreviewPlacement(): PreviewPlacement {
  const stored = storage.getItem<PreviewPlacement>(
    STORAGE_KEYS.itemPreviewPlacement,
  );

  return stored && SUPPORTED_PREVIEW_PLACEMENTS.includes(stored)
    ? stored
    : "right";
}

interface SettingsState {
  previewPlacement: PreviewPlacement;
  actions: {
    setPreviewPlacement: (placement: PreviewPlacement) => void;
  };
}

const useSettingsStore = create<SettingsState>()((set) => ({
  previewPlacement: getInitialPreviewPlacement(),
  actions: {
    setPreviewPlacement: (previewPlacement) => {
      set({ previewPlacement });
      storage.setItem(STORAGE_KEYS.itemPreviewPlacement, previewPlacement);
    },
  },
}));

export const usePreviewPlacement = () =>
  useSettingsStore((state) => state.previewPlacement);

export const useSettingsActions = () =>
  useSettingsStore((state) => state.actions);
